import React from "react";
import styled from "styled-components";

const Title = styled.div`
font-family: Work Sans;

font-style: normal;
font-weight: 500;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
  margin-top:12px;
  & hr {
    margin-top:4px;
  }
`;
const FormSectionTitle = ({ title }) => (
  <Title>
    {title}
  </Title>
);
export default FormSectionTitle;
